'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoPaintcan = function GoPaintcan(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 0c-8.3 0-15 6.7-15 15v2.5c0 1.4 1.1 2.5 2.5 2.5v12.5c0 2.8 5.6 5 12.5 5s12.5-2.2 12.5-5v-12.5c1.4 0 2.5-1.1 2.5-2.5v-2.5c0-8.3-6.7-15-15-15z m7.5 25v1.3c0 0.6-0.6 1.2-1.2 1.2s-1.3-0.6-1.3-1.2v-1.3c0-0.7-0.6-1.2-1.2-1.2s-1.3 0.5-1.3 1.2v6.3c0 0.6-0.6 1.2-1.2 1.2s-1.3-0.6-1.3-1.2v-5c0-0.7-0.6-1.3-1.2-1.3s-1.3 0.6-1.3 1.3v1.2c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-2.5c-1.4 0-2.5-1.1-2.5-2.5v-4.5c2.3 1.2 5.9 2 10 2s7.7-0.8 10-2v4.5c0 1.4-1.1 2.5-2.5 2.5z m-7.5-7.5c-4.2 0-7.8-1-9.3-2.5 1.5-1.5 5.1-2.5 9.3-2.5s7.8 1 9.3 2.5c-1.5 1.5-5.1 2.5-9.3 2.5z m0-7.5c-6.9 0-12.5 2.2-12.5 5 0-6.9 5.6-12.5 12.5-12.5 6.9 0 12.5 5.6 12.5 12.5 0-2.8-5.6-5-12.5-5z' })
        )
    );
};

exports.default = GoPaintcan;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/paintcan.js
// module id = 2226
// module chunks = 168707334958949